import styled from 'styled-components'

export const Wrapper = styled.div`
  line-height: 24px;
`
